import { Col, Row } from "antd";
import InputComponent from "../InputComponent";
import TextareaComponent from "../TextareaComponent";
import FileUploadComponent, { FileData } from "../FileUploadComponent";
import { Dimension } from "../FileUploadComponent/constants";

export type LocalizedContentChanges = Partial<{ title: string; description: string; image: File | null }>;

export interface LocalizedContentTexts {
	title: { label: string; placeholder: string };
	description: { label: string; placeholder: string };
	image: { label: string };
}

export interface LocalizedContentImageUpload {
	maxFileSize: string;
	extensions: ("jpeg" | "jpg" | "png")[];
	dimensions: Dimension[];
}

interface LocalizedContentFieldsProps {
	texts: LocalizedContentTexts;
	title: string;
	description: string;
	imageUrl?: string;
	titleMaxLength: number;
	descriptionMaxLength: number;
	imageUpload: LocalizedContentImageUpload;
	isRequired: boolean;
	onChange: (changes: LocalizedContentChanges) => void;
}

// The title, description and image of one language of a CMS content: the texts on the left, the image on the right.
// The texts show their character count; they are sent as multipart form data, where a line break counts twice.
const LocalizedContentFields = ({
	texts,
	title,
	description,
	imageUrl,
	titleMaxLength,
	descriptionMaxLength,
	imageUpload,
	isRequired,
	onChange,
}: LocalizedContentFieldsProps) => (
	<Row gutter={[20, 20]}>
		<Col xs={24} sm={24} md={12} lg={12}>
			<InputComponent
				title={texts.title.label}
				isRequired={isRequired}
				placeholder={texts.title.placeholder}
				value={title}
				maxLength={titleMaxLength}
				onChange={e => onChange({ title: e.target.value })}
			/>
			<TextareaComponent
				title={texts.description.label}
				isRequired={isRequired}
				placeholder={texts.description.placeholder}
				rows={10}
				resizable={false}
				limitCharacter={descriptionMaxLength}
				lineBreaks="crlf"
				value={description}
				onChange={e => onChange({ description: e.target.value })}
			/>
		</Col>
		<Col xs={24} sm={24} md={12} lg={12}>
			<FileUploadComponent
				title={texts.image.label}
				isRequired={isRequired}
				maxFileSize={imageUpload.maxFileSize}
				dimensions={imageUpload.dimensions}
				allowedExtensions={imageUpload.extensions}
				defaultUrl={imageUrl || undefined}
				onChange={(files: FileData[] | null) => onChange({ image: files?.[0]?.file ?? null })}
				style={{ minHeight: "400px" }}
			/>
		</Col>
	</Row>
);

export default LocalizedContentFields;
